/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TBusinessEntityUpdateRequest,
  TBusinessEntityUpdateModel,
  IMappers,
  TBusinessEntityUpdateResponse,
  TBusinessEntityUpdateResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createBusinessEntityUpdateModel(parameters: TBusinessEntityUpdateRequest): TBusinessEntityUpdateModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'dailyrent',
    pathApi: '/v1/business-entity/update/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IBusinessEntityUpdateOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TBusinessEntityUpdateRequest;
}

export async function fetchBusinessEntityUpdate<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IBusinessEntityUpdateOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TBusinessEntityUpdateResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createBusinessEntityUpdateModel(parameters),
    config,
  )) as FetchResponse<TBusinessEntityUpdateResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TBusinessEntityUpdateResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TBusinessEntityUpdateResponse>;
}
